// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"K0-z"};